"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var log = require("loglevel");
exports.LogLevel = log.levels;
exports.Log = log.getLogger('lib-redux-utils');
exports.Log.setDefaultLevel(exports.LogLevel.SILENT);
function setLogLevel(logLevel) {
    exports.Log.setLevel(logLevel);
}
exports.setLogLevel = setLogLevel;
//# sourceMappingURL=logger.js.map